import { gql } from "graphql-request";

const SERVER_GET_SETTLEMENTS_PDF = gql`
query SERVER_SettlementPdf($id: ID!) {
  settlementPdf(id: $id)
}
`;

export default SERVER_GET_SETTLEMENTS_PDF;
